module.exports = __webpack_public_path__ + "img/mobile.94b1a311.png";